export const removeEmptyKeys = (input) => {
  try {
    if (Array.isArray(input)) {
      // Clean each item in the array
      return input
        .map(removeEmptyKeys)
        .filter((item) =>
          typeof item === "object"
            ? Object.keys(item).length > 0
            : item !== undefined && item !== null
        );
    }
  } catch (error) {
    console.info(error);
  }

  try {
    if (typeof input === "object" && input !== null) {
      return Object.entries(input).reduce((acc, [key, value]) => {
        const cleanedValue = removeEmptyKeys(value);
        const isEmptyArray =
          Array.isArray(cleanedValue) && cleanedValue.length === 0;
        const isEmptyString =
          typeof cleanedValue === "string" && cleanedValue.trim() === "";
        const isNullOrUndefined =
          cleanedValue === null || cleanedValue === undefined;
        const isEmptyObject =
          cleanedValue &&
          typeof cleanedValue === "object" &&
          !Array.isArray(cleanedValue) &&
          Object.keys(cleanedValue).length === 0;

        if (
          isEmptyArray ||
          isEmptyString ||
          isNullOrUndefined ||
          isEmptyObject
        ) {
          return acc;
        }

        acc[key] = cleanedValue;
        return acc;
      }, {});
    }
  } catch (error) {
    console.info(error);
  }

  return input;
};
